export const getPrefersColorSchemeDarkMedia = (): MediaQueryList =>
	window.matchMedia('(prefers-color-scheme: dark)');
